"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showToast = exports.Toast = void 0;
var react_1 = __importDefault(require("react"));
var react_hot_toast_1 = __importStar(require("react-hot-toast"));
var styled_components_1 = __importStar(require("styled-components"));
var ToastInner = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n"], ["\n  position: relative;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n"])));
var durationRunner = (0, styled_components_1.keyframes)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    0% {\n        transform: translateX(0);\n    }\n    100% {\n        transform: translateX(100%);\n    }\n"], ["\n    0% {\n        transform: translateX(0);\n    }\n    100% {\n        transform: translateX(100%);\n    }\n"])));
var ToastDurationRunner = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: ", ";\n  top: 0;\n  left: 0;\n  z-index: -1;\n  animation-name: ", ";\n  animation-duration: ", ";\n  animation-fill-mode: forwards;\n  animation-timing-function: linear;\n\n  ", ":hover & {\n    animation-play-state: paused;\n  }\n"], ["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: ", ";\n  top: 0;\n  left: 0;\n  z-index: -1;\n  animation-name: ", ";\n  animation-duration: ", ";\n  animation-fill-mode: forwards;\n  animation-timing-function: linear;\n\n  ", ":hover & {\n    animation-play-state: paused;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.inverse;
}, durationRunner, function (_a) {
    var durationInSeconds = _a.durationInSeconds;
    return "".concat(durationInSeconds, "s");
}, ToastInner);
/**
 * A component used to push notifications which disappear after a short time.
 *
 * Render `<Toast />` once high up in your application, and then render instances of it with the `showToast` function.
 * `showToast` requires that a `message` be provided and also optionally allows specifying a `duration` for the toast to be present - this defaults to 4s and is paused while the user hovers over the toast.
 */
var Toast = function () {
    var theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(react_hot_toast_1.Toaster, null, function (t) { return (react_1.default.createElement(react_hot_toast_1.ToastBar, { toast: t, style: __assign(__assign({}, t.style), { background: theme.colors.background.frost, color: theme.colors.text.inverse, padding: 0, overflow: 'hidden' }) }, function (_a) {
        var icon = _a.icon, message = _a.message;
        return (react_1.default.createElement(ToastInner, null,
            react_1.default.createElement(ToastDurationRunner, { durationInSeconds: t.duration ? Math.floor(t.duration / 1000) : 4 }),
            icon,
            message));
    })); }));
};
exports.Toast = Toast;
/**
 * Call this function to render instances of Toast
 */
var showToast = function (message, duration) {
    return (0, react_hot_toast_1.default)(message, {
        duration: duration !== null && duration !== void 0 ? duration : 4000,
    });
};
exports.showToast = showToast;
var templateObject_1, templateObject_2, templateObject_3;
